import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import { FontWeights, Typography } from 'builder/styles/typography'
import { Icon20 } from 'builder/components/Icon'
import Media from 'builder/styles/media'

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;
  padding: 32px;

  ${Media.Phone` padding: 16px; `}
`

export const Badge = styled.div<{ visible?: boolean }>`
  display: inline-flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 2px;
  width: fit-content;
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
  color: ${({ theme }) => theme.badge.color};
  background: ${({ theme }) => theme.badge.background};

  ${Media.Phone`
    display: none;
  `}
`

export const BadgeText = styled.p`
  ${Typography.Tiny}
  ${FontWeights.DemiBold}
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  ${Media.Phone`
    text-align: center;
  `}
`

export const Header = styled.h2`
  ${Typography.Subhead}
  ${FontWeights.Medium}
`

export const SubHeader = styled.p`
  ${Typography.Caption}
  ${FontWeights.Regular}
`

export const ActionContainer = styled.div`
  margin-top: auto;
  display: flex;
  width: 100%;
`

export const ButtonContainer = styled.button`
  width: 100%;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  align-items: center;
  width: 100%;

  padding: 11px;
  border-radius: 8px;
  border: 1px solid ${Colors.Neutral15};
  background: ${Colors.White};
`

export const ActionText = styled.p`
  ${Typography.Body}
  ${FontWeights.Regular}

  color: ${Colors.Neutral90};
`

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
`

export const Icon = styled(Icon20.ChevronRightRegular)`
  color: ${Colors.Neutral80};
`

export const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 67px;
  height: 24px;
  border-radius: 2px;
`

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`
